'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _translate = require('../../redux/i18n/translate');

var _translate2 = _interopRequireDefault(_translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return { currentLanguage: state.language.lang };
}, {}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Menu, _Component);

  function Menu(props) {
    (0, _classCallCheck3.default)(this, Menu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props));

    _this.state = {
      opened: false,
      menuHovered: false
    };
    return _this;
  }

  (0, _createClass3.default)(Menu, [{
    key: 'showMenu',
    value: function showMenu() {
      this.setState({
        menuHovered: true,
        opened: true
      });

      document.getElementsByClassName('sidebar')[0].classList.add('tras');
    }
  }, {
    key: 'hideMenu',
    value: function hideMenu() {
      this.setState({
        opened: false,
        menuHovered: false
      });

      document.getElementsByClassName('sidebar')[0].classList.remove('tras');
    }
  }, {
    key: 'toggleMenu',
    value: function toggleMenu() {
      this.state.opened ? this.hideMenu() : this.showMenu();
    }
  }, {
    key: 'render',
    value: function render() {
      var menuOpened = this.state.opened ? " open-shows-menu" : " close-shows-menu";
      var menuHovered = this.state.menuHovered ? " siHover" : " noHover";
      var _props$strings = this.props.strings,
          elem1 = _props$strings.elem1,
          elem2 = _props$strings.elem2,
          elem3 = _props$strings.elem3,
          elem4 = _props$strings.elem4;
      var _elem1$items = elem1.items,
          item1 = _elem1$items.item1,
          item2 = _elem1$items.item2,
          item3 = _elem1$items.item3,
          item4 = _elem1$items.item4;


      return _react2.default.createElement(
        'div',
        { className: "containerMenu" + menuOpened },
        _react2.default.createElement(
          'nav',
          { className: "principalMenu" + menuOpened },
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/" + this.context.project + "/" + this.props.currentLanguage + elem2.url, draggable: 'false' },
                _react2.default.createElement(
                  'div',
                  { className: 'menu-top', onMouseEnter: this.hideMenu.bind(this) },
                  _react2.default.createElement(
                    'span',
                    { className: 'text' },
                    ' ',
                    elem2.title,
                    ' '
                  ),
                  _react2.default.createElement('span', { className: 'bottomLine' })
                )
              )
            ),
            _react2.default.createElement('span', { className: 'verticalLine' }),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'div',
                { className: "toggleMenu shows-menu-toggler menu-top" + menuHovered, onMouseEnter: this.showMenu.bind(this), onClick: this.toggleMenu.bind(this) },
                _react2.default.createElement(
                  'span',
                  { className: 'text' },
                  ' ',
                  elem1.title,
                  ' '
                ),
                _react2.default.createElement('span', { className: 'bottomLine' }),
                _react2.default.createElement('i', { className: 'icon-arrow' })
              )
            ),
            _react2.default.createElement('span', { className: 'verticalLine' }),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/" + this.context.project + "/" + this.props.currentLanguage + elem3.url, draggable: 'false' },
                _react2.default.createElement(
                  'div',
                  { className: 'menu-top', onMouseEnter: this.hideMenu.bind(this) },
                  _react2.default.createElement(
                    'span',
                    { className: 'text' },
                    ' ',
                    elem3.title,
                    ' '
                  ),
                  _react2.default.createElement('span', { className: 'bottomLine' })
                )
              )
            ),
            _react2.default.createElement('span', { className: 'verticalLine' }),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/" + this.context.project + "/" + this.props.currentLanguage + elem4.url, draggable: 'false' },
                _react2.default.createElement(
                  'div',
                  { className: 'menu-top', onMouseEnter: this.hideMenu.bind(this) },
                  _react2.default.createElement(
                    'span',
                    { className: 'text' },
                    ' ',
                    elem4.title,
                    ' '
                  ),
                  _react2.default.createElement('span', { className: 'bottomLine' })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'nav',
          { className: 'submenu shows-menu', onMouseLeave: this.hideMenu.bind(this) },
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              { className: 'box-1', onClick: this.hideMenu.bind(this) },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/" + this.context.project + "/" + this.props.currentLanguage + item1.url, draggable: 'false' },
                _react2.default.createElement(
                  'div',
                  { className: 'box-title' },
                  _react2.default.createElement(
                    'p',
                    { className: 'title' },
                    item1.title
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'subtitle' },
                    item1.subtitle
                  )
                ),
                _react2.default.createElement('img', { draggable: 'false', src: this.context.baseUrl + item1.image, className: ' box-cover' })
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'box-2', onClick: this.hideMenu.bind(this) },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/" + this.context.project + "/" + this.props.currentLanguage + item2.url, draggable: 'false' },
                _react2.default.createElement(
                  'div',
                  { className: 'box-title' },
                  _react2.default.createElement(
                    'p',
                    { className: 'title' },
                    item2.title
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'subtitle' },
                    item2.subtitle
                  )
                ),
                _react2.default.createElement('img', { draggable: 'false', src: this.context.baseUrl + item2.image, className: ' box-cover' })
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'box-3', onClick: this.hideMenu.bind(this) },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/" + this.context.project + "/" + this.props.currentLanguage + item3.url, draggable: 'false' },
                _react2.default.createElement(
                  'div',
                  { className: 'box-title' },
                  _react2.default.createElement(
                    'p',
                    { className: 'title' },
                    item3.title
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'subtitle' },
                    item3.subtitle
                  )
                ),
                _react2.default.createElement('img', { draggable: 'false', src: this.context.baseUrl + item3.image, className: ' box-cover' })
              )
            )
          )
        )
      );
    }
  }]);
  return Menu;
}(_react.Component), _class2.propTypes = {
  strings: _react.PropTypes.object
}, _class2.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = (0, _translate2.default)('Menu')(Menu);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/Menu.js
// module id = 795
// module chunks = 0